export default "__VITE_ASSET__DJMqy5fi__"